<template>
  <div id="app">
    <DialogProvider :ModalComponent="LnDialogVue">
      <!-- <keep-alive> -->
      <router-view />
      <!-- </keep-alive> -->
    </DialogProvider>
  </div>
</template>

<script>
import { DialogProvider } from '@/features/dialog';
import LnDialogVue from '@/features/dialog/LnDialog.vue';
import { keepAliveInclude } from './hooks/useKeepAlive';
import { IS_YS_DOMAIN } from '@/utils/helper';

export default {
  name: 'app',
  components: {
    DialogProvider
  },
  setup() {
    if (IS_YS_DOMAIN) {
      document.title = 'Land of Arielia-Official Top-Up Center';
      const metaDescription = document.querySelector('meta[name="description"]');
      const description = 'Welcome to the [Azure Tale] Official Top-Up Center. Enjoy a secure, fast, and reliable payment experience directly from the developer.';
      if (metaDescription) {
        metaDescription.setAttribute(
          'content',
          description
        );
      } else {
        const meta = document.createElement('meta');
        meta.name = 'description';
        meta.content = description;
        document.head.appendChild(meta);
      }
      let favicon = document.head.querySelector('link[rel="icon"]');
      const url = require('@/assets/imgs/ys/favicon.ico');
      if (favicon !== null) {
        favicon.href = url;
      } else {
        favicon = document.createElement('link');
        favicon.rel = 'shortcut icon';
        favicon.href = url;
        document.head.appendChild(favicon);
      }
    }
    return {
      LnDialogVue,
      keepAliveInclude
    };
  }
};
</script>

<style lang="scss">
.part-title {
  font-family: SourceHanSansCN;
  font-weight: 800;
  font-size: 0.3rem;
  color: #000000;
  display: flex;
  align-items: center;
  padding: 0.2rem 0;

  &::before {
    content: '';
    display: inline-block;
    width: 0.08rem;
    height: 0.45rem;
    background: #ffc100;
    margin-right: 0.15rem;
  }
}
</style>
